import { createContext, useContext, useState, useEffect } from "react";
import { AuthAPI } from "./api";

const AdminContext = createContext(null);
export const useAdmin = () => useContext(AdminContext);

export const AdminProvider = ({ children }) => {
  const [authed, setAuthed] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activity, setActivity] = useState([]);

  useEffect(() => {
    const token = sessionStorage.getItem("veedu_token");
    if (token) {
      AuthAPI.currentUser()
        .then((userData) => {
          setUser(userData);
          setAuthed(true);
        })
        .catch(() => {
          sessionStorage.removeItem("veedu_token");
          setAuthed(false);
          setUser(null);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const data = await AuthAPI.login({ email, password });
      if (data && data.token) {
        sessionStorage.setItem("veedu_token", data.token);
        setUser({
          userId: data.userId || null,
          username: data.username,
          role: data.role,
        });
        setAuthed(true);
        return true;
      }
      return false;
    } catch (error) {
      console.error("Login failed", error);
      return false;
    }
  };

  const logout = async () => {
    try {
      await AuthAPI.logout();
    } catch (e) {
      console.error("Logout failed", e);
    } finally {
      sessionStorage.removeItem("veedu_token");
      setAuthed(false);
      setUser(null);
    }
  };

  const log = (action, target) =>
    setActivity((a) => [{ action, target, when: "Just now" }, ...a].slice(0, 12));

  return (
    <AdminContext.Provider
      value={{ authed, user, loading, login, logout, activity, log }}
    >
      {children}
    </AdminContext.Provider>
  );
};
